import React, { useState, useEffect } from 'react';
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { Link } from "react-router-dom";

const VendorSubCat = ({ show, onClose }) => {
    const [selectedOption, setSelectedOption] = useState(null);    
    const [isFocused, setIsFocused] = useState(false);
    
  
    useEffect(() => {
        if (isFocused) {
        console.log('The input is focused!');
        }
    }, [isFocused]);
    
    const vendor_cat = [
        { value: "0", label: "Vegetables"},
        { value: "1", label: "Vessels" },
        { value: "2", label: "Packing Container" },
    ];

    return (
        <Modal className="modal fade" show={show}  size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#b7dfd0' }}>
                    <h3 className="modal-title">Create Vendor Sub Category</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-4">
                            <label className="text-black font-w500 fs-7">Vendor Category <span className="required">*</span></label>
                            <Select placeholder='Select Vendor Category'
                                value={selectedOption}
                                onChange={setSelectedOption}
                                options={vendor_cat}
                            />
                        </div>  
                        <div className="col-lg-12 mb-4">
                            <label className="text-black font-w500 fs-7">Vendor Sub Category<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Vendor Sub Category" />
                        </div>                     
                        <div className="col-lg-12 mb-4">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <input type="text" className="form-control" placeholder="Enter Description" />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Create Vendor Sub Category</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default VendorSubCat;
